<template>
    <div class="twenty-four-retrospective">
        <div class="modal fade retrospective-2024" id="retrospective-2024" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document" style="width: 800px;">
                <div @click="retrospective.versions[page].value == 0 ? bodyClick() : ''"  class="modal-content">
                    <button
                        v-if="page > 0"
                        class="ba-btn ba-btn-normal ba-sm ba-rounded back-btn"
                        @click.stop="defineRetrospectivePage('back')"
                        :disabled="showShareContent"
                    >
                        <builderall-icon code='arrow-left'></builderall-icon>
                    </button>
                    <builderall-loader class="loader-image" :loading="retrospectiveFile[page].loading" :text="t.retrospective_loader_message">
                        <img
                            v-for="i in 8" :key="i"
                            :src="defineLink(i - 1)"
                            v-if="page === i - 1"
                            :class="{'pointer': retrospective.versions[page].value == 0}"
                            @load="onImageLoad"
                        >
                    </builderall-loader>
                    <button
                        v-if="retrospective.versions[page].value > 0 && !retrospectiveFile[page].loading"
                        class="ba-share-btn ba-btn ba-md ba-blue"
                        :style="{top: getMarginShareButton('y'), left: getMarginShareButton('x')}"
                        @click="openShareModal()"
                        :disabled="showShareContent"
                    >
                        {{ t.label_share }}
                    </button>
                    <button
                        v-if="page < 7"
                        class="ba-btn ba-btn-normal ba-sm ba-rounded next-btn"
                        @click.stop="defineRetrospectivePage('next')"
                        :disabled="showShareContent"
                    >
                        <builderall-icon code='arrow-right'></builderall-icon>
                    </button>
                </div>
                <div v-if="showShareContent" class="share-content">
                    <builderall-loader class="loader-shortener-link" :loading="loadingLink">
                        <div class='ba-card ba-w-100'>
                            <div class='ba-top'>
                                <span class='ba-title'>{{ t.label_share }}</span>
                                <div class='ba-box-items ba-flex ba-gp-1'>
                                    <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="showShareContent = false">
                                        <builderall-icon code='64f7' />
                                    </button>
                                </div>
                            </div>
                            <div class='ba-content ba-w-100 ba-grid ba-gp-1'>
                                <div class="social-share">
                                    <div class="ba-flex ba-f-column ba-ai-center">
                                        <button class="ba-btn-whatsapp" @click="shareOnSocial('whatsapp')">
                                            <svg width="25" height="25" viewBox="0 0 25 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.31159 18.7004L2.82394 20.6472C2.76176 20.8999 2.76583 21.1643 2.83574 21.4149C2.90565 21.6655 3.03904 21.8938 3.22301 22.0778C3.40698 22.2618 3.63531 22.3951 3.88592 22.4651C4.13653 22.535 4.40094 22.539 4.65358 22.4769L6.59284 21.993C7.2311 21.8364 7.90346 21.899 8.50186 22.1707C10.7645 23.1813 13.3095 23.3679 15.6953 22.6981C18.0811 22.0283 20.1571 20.5443 21.563 18.5036C22.9689 16.463 23.616 13.9945 23.392 11.5266C23.1679 9.05868 22.0869 6.7471 20.3365 4.99299C18.5861 3.23889 16.2768 2.15299 13.8094 1.92374C11.3419 1.69449 8.87211 2.33636 6.82851 3.73796C4.78491 5.13956 3.29652 7.21243 2.62165 9.59682C1.94678 11.9812 2.12802 14.5266 3.13392 16.7914C3.40645 17.3895 3.46905 18.0622 3.31159 18.7004ZM8.77026 7.8889C8.96148 7.70971 9.20543 7.59702 9.46582 7.56758C9.63972 7.56758 10.3353 7.50331 10.5508 8.02121C10.7662 8.5391 11.3068 9.80926 11.3522 9.93401C11.3941 10.0015 11.4182 10.0785 11.4221 10.1579C11.4261 10.2372 11.4098 10.3163 11.3748 10.3876C11.3094 10.5433 11.2215 10.6885 11.114 10.8186C10.9855 10.9698 10.8418 11.155 10.736 11.2722C10.6301 11.3894 10.4714 11.5406 10.6226 11.7977C11.0063 12.4567 11.4852 13.0554 12.044 13.5744C12.6625 14.1196 13.3712 14.5532 14.1382 14.8559C14.399 14.9844 14.5503 14.9617 14.7015 14.7916C14.8527 14.6215 15.3517 14.0356 15.5256 13.7823C15.6994 13.529 15.8733 13.5668 16.1115 13.6538C16.3496 13.7407 17.6236 14.3645 17.892 14.493C18.1604 14.6215 18.3229 14.6858 18.391 14.7916C18.4617 15.2059 18.4092 15.6318 18.2398 16.0164C18.0189 16.5967 17.581 17.0685 17.0187 17.3319C16.516 17.5021 15.9603 17.5928 13.4918 16.5986C10.8721 15.525 9.05378 12.8788 8.92525 12.7049C8.79672 12.531 7.863 11.3062 7.863 10.0399C7.84729 9.63618 7.9204 9.23398 8.07717 8.86166C8.23393 8.48934 8.47054 8.15598 8.77026 7.88512V7.8889Z"/>
                                            </svg>
                                        </button>
                                        <span>{{ t.label_whatsapp }}</span>
                                    </div>
                                    <div class="ba-flex ba-f-column ba-ai-center">
                                        <button class="ba-btn-linkedin" @click="shareOnSocial('linkedin')">
                                            <builderall-icon code='linkedin'></builderall-icon>
                                        </button>
                                        <span>LinkedIn</span>
                                    </div>
                                    <div class="ba-flex ba-f-column ba-ai-center">
                                        <button class="ba-btn-facebook" @click="shareOnSocial('facebook')">
                                            <builderall-icon code='facebook'></builderall-icon>
                                        </button>
                                        <span>{{ t.label_facebook_v5 }}</span>
                                    </div>
                                    <div class="ba-flex ba-f-column ba-ai-center">
                                        <button class="ba-btn-email" @click="shareOnSocial('email')">
                                            <builderall-icon code='cf23'></builderall-icon>
                                        </button>
                                        <span>{{ t.label_email }}</span>
                                    </div>
                                    <div class="ba-flex ba-f-column ba-ai-center">
                                        <button class="ba-btn-x" @click="shareOnSocial('x')">
                                            <builderall-icon code='new-twitter'></builderall-icon>
                                        </button>
                                        <span>X</span>
                                    </div>
                                </div>
                                <div class='ba-box-input-icon' @click="copyLink()">
                                    <input type='text' class='ba-input ba-md' :value="shareFileLink" readonly />
                                    <div>
                                        <button class='ba-button'>
                                            <builderall-icon :code='loadingCopyButton ? `ad00` : `b54c`'></builderall-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </builderall-loader>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import qs from 'qs';
    export default {
        name: "twenty-four-retrospective",
        props: ['data','user','t','retrospective'],
        data() {
            return {
                page: 0,
                showShareContent: false,
                loadingCopyButton: false,
                shareFileLink: null,
                loadingLink: false,
                retrospectiveFile: [
                    {   slug: 'websites_published',
                        loading: true, 
                        positions: {
                            br: {x: '47', y: '72'},
                            de: {x: '50', y: '72'},
                            es: {x: '50', y: '72'},
                            fr: {x: '50', y: '72'},
                            it: {x: '50', y: '72'},
                            us: {x: '50', y: '72'},
                        }
                    },
                    {
                        slug: 'website_edits_made',
                        loading: true,
                        positions: {
                            br: {x: '51', y: '74'},
                            de: {x: '53', y: '79.5'},
                            es: {x: '53', y: '74'},
                            fr: {x: '53', y: '68'},
                            it: {x: '53', y: '68'},
                            us: {x: '53', y: '74'},
                        }
                    },
                    {
                        slug: 'emails_sent',
                        loading: true,
                        positions: {
                            br: {x: '9', y: '72'},
                            de: {x: '13', y: '72'},
                            es: {x: '11', y: '72'},
                            fr: {x: '11', y: '72'},
                            it: {x: '11', y: '72'},
                            us: {x: '11', y: '72'},
                        }
                    },
                    {
                        slug: 'email_subscribers_gained',
                        loading: true,
                        positions: {
                            br: {x: '11', y: '82.5'},
                            de: {x: '15', y: '82.5'},
                            es: {x: '15', y: '82.5'},
                            fr: {x: '15', y: '70.5'},
                            it: {x: '15', y: '70.5'},
                            us: {x: '15', y: '70.5'},
                        }
                    },
                    {
                        slug: 'website_visitors',        
                        loading: true,
                        positions: {
                            br: {x: '12', y: '80.5'},
                            de: {x: '15', y: '80'},
                            es: {x: '15', y: '69'},
                            fr: {x: '15', y: '69'},
                            it: {x: '15', y: '81.5'},
                            us: {x: '15', y: '69'},
                        }
                    },
                    {
                        slug: 'quizzes_created',         
                        loading: true,
                        positions: {
                            br: {x: '49', y: '69'},
                            de: {x: '50', y: '69'},
                            es: {x: '52', y: '69'},
                            fr: {x: '50', y: '69'},
                            it: {x: '52', y: '69'},
                            us: {x: '52', y: '69'},
                        }
                    },
                    {
                        slug: 'courses_created',         
                        loading: true,
                        positions: {
                            br: {x: '43', y: '70'},
                            de: {x: '44', y: '70'},
                            es: {x: '45', y: '70'},
                            fr: {x: '45', y: '70'},
                            it: {x: '45', y: '70'},
                            us: {x: '45', y: '70'},
                        }
                    },
                    {
                        slug: 'students_registered',     
                        loading: true,
                        positions: {
                            br: {x: '11', y: '77'},
                            de: {x: '13', y: '77'},
                            es: {x: '11', y: '77'},
                            fr: {x: '11', y: '66'},
                            it: {x: '11', y: '77'},
                            us: {x: '11', y: '77'},
                        }
                    }
                ]
            }
        },
        methods: {
            getMarginShareButton(type){
                return this.retrospectiveFile[this.page].positions[this.user.pais][type] + '%'
            },
            bodyClick(){
                if(this.retrospective.versions[this.page].empty_route){
                    window.location.href = this.retrospective.versions[this.page].empty_route
                }
            },
            async copyLink(){
                this.loadingCopyButton = true
                await navigator.clipboard.writeText(this.shareFileLink)
                setTimeout(() => {
                    this.loadingCopyButton = false
                }, 3000)
            },
            shareOnSocial(media) {
                let message = this.retrospective.versions[this.page]['message']
                message = message.replace('NUMBER_VALUE', this.retrospective.versions[this.page]['value'])
                const encodedMessage = encodeURIComponent(message)
                const encodedImageUrl = encodeURIComponent(this.shareFileLink)

                const platforms = {
                    whatsapp: `https://web.whatsapp.com/send?text=${encodedMessage}%0A${encodedImageUrl}`,
                    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedImageUrl}`,
                    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedImageUrl}&quote=${encodedMessage}`,
                    email:    `mailto:?subject=${encodedMessage}&body=${encodedMessage} ${encodedImageUrl}`,
                    x:        `https://twitter.com/intent/tweet?text=${encodedMessage}&url=${encodedImageUrl}`
                }

                const sharerUrl = platforms[media]
                window.open(sharerUrl, '_blank')
            },
            openShareModal(){
                this.shareFileLink = this.defineLink(null, true)
                this.getShortUrl(this.shareFileLink)
                this.showShareContent = true
            },
            defineLink(page, share){
                const userData = btoa(`user=${this.user.id}&year=2024&image=${this.retrospective.versions[!page ? this.page : page]['slug']}`)
                return `${window.location.protocol}//${window.location.hostname}/${window.location.pathname.slice(1,3)}/retrospective/${share ? 'share/' : ''}${userData}`
            },
            defineRetrospectivePage(page){
                this.retrospectiveFile[this.page].loading = true
                this.page = page == 'next' ? this.page+1 : page == 'back' ? this.page-1 : page
            },
            closePopup(popup){
                $(`${popup}`).modal('hide')
            },
            onImageLoad(){
                this.retrospectiveFile[this.page].loading = false
            },
            getShortUrl(url){
                this.loadingLink = true;

                axios.post('/us/office/create/shortener-url', qs.stringify({ url: url }))
                    .then(response => {
                        if(response.data.data.short_url){
                            this.shareFileLink = response.data.data.short_url
                        }
                    })
                    .catch(error => {
                        console.error('Error to create short url', error)
                    }).finally(res => {
                        this.loadingLink = false;
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .retrospective-2024{
        top: 15%;
        .back-btn,
        .next-btn{
            position: absolute;
            top: 50%;
            z-index: 1;
            transition: 0s;
        }
        .modal-content{
            border-radius: 16px;
        }
        img{
            width: 100%;
            border-radius: 16px;
            &.pointer{
                cursor: pointer;
            }
        }
        .back-btn{
            left: 1%;
        }
        .next-btn{
            right: 1%;
        }
        .ba-share-btn{
            position: absolute;
            transition: 0s;
        }
        .loader-image{
            min-width: 800px;
            min-height: 448px;
        }
        .loader-shortener-link{
            border-radius: 16px;
        }
        .share-content{
            position: absolute;
            top: 25%;
            background-color: white;
            width: 90%;
            left: 5%;
            border-radius: 16px;
            animation: toTop 1s;
            .social-share{
                display: flex;
                gap: 16px;
                justify-content: space-evenly;
                flex-wrap: wrap;
                button{
                    border: none;
                    background: none;
                    border-radius: 50%;
                    padding: 10px;
                    height: 45px;
                    width: 45px;
                    builderall-icon{
                        --builderall-icon-color: white;
                    }
                    svg{
                        color: white;
                    }
                    &.ba-btn-whatsapp{
                        background-color: #22D063;
                    }
                    &.ba-btn-linkedin{
                        background-color: #0076B2;

                    }
                    &.ba-btn-facebook{
                        background-color: #2164D8;
                    }
                    &.ba-btn-email{
                        background-color: #EBF0F5;
                        builderall-icon{
                            --builderall-icon-color: #8F9FB6;
                        }
                    }
                    &.ba-btn-x{
                        background-color: #111827;
                    }
                    &:hover{
                        opacity: 0.8;
                    }
                }
                span{
                    font-size: 12px;
                    margin-top: 6px;
                }
            }
        }
        &:has(.share-content){
            .modal-content{
                filter: brightness(0.7);
                transition: 1s;
            }
        }
    }
    @keyframes toTop {
        0% {opacity: 0; top: 100%}
        100% {opacity: 1; top: 25%}
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/dashboard/banners/components/TwentyFourRetrospective.vue